import { cn } from '@/lib/utils'

/**
 * LOCKED — verdant's KPI card triple (round-1 named borrow): small-caps label,
 * big tabular figure, one-line qualifier carrying the denominator. The
 * qualifier ink is muted-foreground (AA), never --color-faint.
 */
export function KpiCard({
  label,
  figure,
  qualifier,
  className,
}: {
  label: string
  figure: React.ReactNode
  qualifier: React.ReactNode
  className?: string
}) {
  return (
    <div className={cn('rounded-lg border border-border bg-card px-4 py-3', className)}>
      <div className="text-[0.6875rem] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
        {label}
      </div>
      <div className="v-figure mt-1 font-serif text-[1.625rem] font-semibold leading-8 tabular-nums text-foreground">
        {figure}
      </div>
      <div className="mt-0.5 text-xs text-muted-foreground">{qualifier}</div>
    </div>
  )
}
